import { useEffect } from "react";

interface SEOProps {
  title: string;
  description?: string;
}

export default function usePageSEO({ title }: SEOProps) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}